var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "token-hub"
  }, [_c("main", [_c("section", {
    staticClass: "hub-hero",
    attrs: {
      "aria-labelledby": "tokenhub-hero-title"
    }
  }, [_c("img", {
    staticClass: "hub-hero__image",
    attrs: {
      src: _vm.heroImage,
      alt: "",
      "aria-hidden": "true"
    }
  }), _c("div", {
    staticClass: "hub-container hub-hero__content"
  }, [_c("h1", {
    attrs: {
      id: "tokenhub-hero-title"
    }
  }, [_vm._v("同花顺Token Hub")]), _c("p", {
    staticClass: "hub-hero__caption"
  }, [_vm._v("更懂金融机构的专属模型、算力管理平台")]), _vm._m(0), _c("button", {
    staticClass: "hub-button",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleAppointment
    }
  }, [_vm._v("立刻预约 "), _c("HubIcon")], 1)])]), _c("section", {
    staticClass: "hub-section hub-value",
    attrs: {
      "aria-labelledby": "tokenhub-value-title"
    }
  }, [_c("div", {
    staticClass: "hub-container"
  }, [_vm._m(1), _c("div", {
    staticClass: "hub-grid hub-grid--four"
  }, _vm._l(_vm.advantages, function (item) {
    return _c("article", {
      key: item.tag,
      staticClass: "hub-card value-card"
    }, [_c("span", {
      staticClass: "hub-tag"
    }, [_vm._v(_vm._s(item.tag))]), _c("h3", [_vm._v(_vm._s(item.title))]), _vm._l(item.description, function (line) {
      return _c("p", {
        key: line
      }, [_vm._v(_vm._s(line))]);
    })], 2);
  }), 0)])]), _c("section", {
    staticClass: "hub-section hub-section--soft",
    attrs: {
      "aria-labelledby": "tokenhub-workflow-title"
    }
  }, [_c("div", {
    staticClass: "hub-container"
  }, [_vm._m(2), _c("div", {
    staticClass: "workflow-panel"
  }, [_c("div", {
    staticClass: "workflow-tabs",
    attrs: {
      role: "tablist",
      "aria-label": "服务类型"
    }
  }, _vm._l(_vm.workflowTabs, function (tab, index) {
    return _c("button", {
      key: tab.value,
      class: {
        active: _vm.workflowMode === tab.value
      },
      attrs: {
        id: `workflow-tab-${tab.value}`,
        type: "button",
        role: "tab",
        "aria-selected": _vm.workflowMode === tab.value,
        tabindex: _vm.workflowMode === tab.value ? 0 : -1
      },
      on: {
        click: function ($event) {
          _vm.workflowMode = tab.value;
        },
        keydown: function ($event) {
          return _vm.handleTabKeydown($event, index);
        }
      }
    }, [_vm._v(_vm._s(tab.label))]);
  }), 0), _c("div", {
    staticClass: "workflow-stage",
    attrs: {
      role: "tabpanel",
      "aria-labelledby": `workflow-tab-${_vm.workflowMode}`
    }
  }, [_c("div", {
    staticClass: "workflow-node workflow-node--apps"
  }, [_c("span", {
    staticClass: "workflow-node__eyebrow"
  }, [_vm._v("业务应用")]), _c("div", {
    staticClass: "workflow-app"
  }, [_c("HubIcon", {
    attrs: {
      name: "app"
    }
  }), _vm._m(3)], 1), _c("div", {
    staticClass: "workflow-app"
  }, [_c("HubIcon", {
    attrs: {
      name: "app"
    }
  }), _vm._m(4)], 1)]), _c("div", {
    staticClass: "workflow-arrow"
  }, [_c("span", [_vm._v("请求")]), _c("HubIcon")], 1), _c("div", {
    staticClass: "workflow-node workflow-node--hub"
  }, [_c("HubIcon", {
    attrs: {
      name: "layers"
    }
  }), _c("strong", [_vm._v("Token Hub")]), _c("span", [_vm._v("衔接业务与模型")]), _c("small", [_vm._v("服务接入 · 持续支持")])], 1), _c("div", {
    staticClass: "workflow-arrow"
  }, [_c("span", [_vm._v("调用")]), _c("HubIcon")], 1), _c("div", {
    staticClass: "workflow-node workflow-node--resource"
  }, [_vm.workflowMode === "compute" ? [_c("span", {
    staticClass: "workflow-node__eyebrow"
  }, [_vm._v("你的专属算力")]), _c("HubIcon", {
    attrs: {
      name: "server"
    }
  }), _c("strong", [_vm._v("整台机器对应的全部算力")]), _c("small", [_vm._v("模型已部署，算力专属使用")]), _vm._m(5)] : [_c("span", {
    staticClass: "workflow-node__eyebrow"
  }, [_vm._v("按需调用的模型服务")]), _vm._m(6), _c("strong", [_vm._v("多个模型，共用统一余额")]), _c("small", [_vm._v("根据模型价格与实际用量计费")]), _vm._m(7)]], 2), _vm._m(8)]), _c("div", {
    staticClass: "workflow-steps"
  }, _vm._l(_vm.activeWorkflowSteps, function (step, index) {
    return _c("article", {
      key: step.title
    }, [_c("span", [_vm._v("0" + _vm._s(index + 1))]), _c("div", [_c("strong", [_vm._v(_vm._s(step.title))]), _c("p", [_vm._v(_vm._s(step.description))])])]);
  }), 0)]), _c("p", {
    staticClass: "hub-note"
  }, [_vm._v("调用流程为服务使用示意，具体接入方式与可用模型按方案确认。")])])]), _c("section", {
    staticClass: "hub-section",
    attrs: {
      "aria-labelledby": "tokenhub-services-title"
    }
  }, [_c("div", {
    staticClass: "hub-container"
  }, [_vm._m(9), _c("div", {
    staticClass: "service-grid"
  }, _vm._l(_vm.services, function (service) {
    return _c("article", {
      key: service.title,
      staticClass: "service-card"
    }, [_c("div", {
      staticClass: "service-card__top"
    }, [_c("span", {
      staticClass: "service-icon"
    }, [_c("HubIcon", {
      attrs: {
        name: service.icon
      }
    })], 1), _c("span", {
      staticClass: "hub-tag"
    }, [_vm._v(_vm._s(service.tag))])]), _c("h3", [_vm._v(_vm._s(service.title))]), _c("p", {
      staticClass: "service-card__intro"
    }, [_vm._v(_vm._s(service.intro))]), _c("dl", _vm._l(service.facts, function (fact) {
      return _c("div", {
        key: fact.label
      }, [_c("dt", [_vm._v(_vm._s(fact.label))]), _c("dd", [_vm._v(_vm._s(fact.value))])]);
    }), 0), _c("button", {
      staticClass: "hub-button",
      attrs: {
        type: "button"
      },
      on: {
        click: _vm.handleAppointment
      }
    }, [_vm._v("立刻预约 "), _c("HubIcon")], 1)]);
  }), 0)])]), _c("section", {
    staticClass: "hub-section hub-section--soft",
    attrs: {
      "aria-labelledby": "tokenhub-platform-title"
    }
  }, [_c("div", {
    staticClass: "hub-container"
  }, [_vm._m(10), _c("div", {
    staticClass: "hub-grid hub-grid--four platform-grid"
  }, _vm._l(_vm.platformSupport, function (item) {
    return _c("article", {
      key: item.title,
      staticClass: "hub-card platform-card"
    }, [_c("h3", [_vm._v(_vm._s(item.title))]), _c("p", [_vm._v(_vm._s(item.description))]), _c("ul", _vm._l(item.points, function (point) {
      return _c("li", {
        key: point
      }, [_c("span", [_c("HubIcon", {
        attrs: {
          name: "check"
        }
      })], 1), _vm._v(_vm._s(point))]);
    }), 0), _c("div", {
      staticClass: "platform-visual",
      attrs: {
        "aria-hidden": "true"
      }
    }, _vm._l(item.visual, function (label) {
      return _c("span", {
        key: label
      }, [_vm._v(_vm._s(label))]);
    }), 0)]);
  }), 0), _c("p", {
    staticClass: "hub-note"
  }, [_vm._v("知识、工具及治理能力按方案组合，具体配置、部署方式与交付范围以双方确认为准。")])])]), _c("section", {
    staticClass: "hub-section",
    attrs: {
      "aria-labelledby": "tokenhub-security-title"
    }
  }, [_c("div", {
    staticClass: "hub-container"
  }, [_vm._m(11), _c("div", {
    staticClass: "hub-grid hub-grid--three"
  }, _vm._l(_vm.security, function (item) {
    return _c("article", {
      key: item.title,
      staticClass: "hub-card security-card"
    }, [_c("span", {
      staticClass: "security-icon"
    }, [_c("HubIcon", {
      attrs: {
        name: item.icon
      }
    })], 1), _c("h3", [_vm._v(_vm._s(item.title))]), _c("p", [_vm._v(_vm._s(item.description))])]);
  }), 0)])]), _c("section", {
    staticClass: "hub-section",
    attrs: {
      "aria-labelledby": "tokenhub-delivery-title"
    }
  }, [_c("div", {
    staticClass: "hub-container"
  }, [_vm._m(12), _c("ol", {
    staticClass: "delivery-grid"
  }, _vm._l(_vm.delivery, function (item, index) {
    return _c("li", {
      key: item.title,
      staticClass: "hub-card value-card delivery-card"
    }, [_c("span", {
      staticClass: "delivery-number"
    }, [_vm._v("0" + _vm._s(index + 1))]), _c("h3", [_vm._v(_vm._s(item.title))]), _c("p", [_vm._v(_vm._s(item.description))]), _c("strong", [_vm._v(_vm._s(item.output))])]);
  }), 0)])]), _c("section", {
    staticClass: "hub-section business-section",
    attrs: {
      "aria-labelledby": "tokenhub-business-title"
    }
  }, [_c("div", {
    staticClass: "hub-container"
  }, [_vm._m(13), _c("div", {
    staticClass: "hub-grid hub-grid--three business-grid"
  }, _vm._l(_vm.business, function (item) {
    return _c("article", {
      key: item.number
    }, [_c("span", [_vm._v(_vm._s(item.number))]), _c("h3", [_vm._v(_vm._s(item.title))]), _c("p", [_vm._v(_vm._s(item.description))])]);
  }), 0), _vm._m(14)])]), _c("section", {
    staticClass: "hub-section hub-contact",
    attrs: {
      "aria-labelledby": "tokenhub-contact-title"
    }
  }, [_c("div", {
    staticClass: "hub-container"
  }, [_c("div", {
    staticClass: "quote-panel"
  }, [_vm._m(15), _c("button", {
    staticClass: "hub-button hub-button--white",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleAppointment
    }
  }, [_vm._v("立刻预约 "), _c("HubIcon")], 1)]), _c("div", {
    staticClass: "faq-panel"
  }, [_c("h3", [_vm._v("可能还想了解")]), _c("div", _vm._l(_vm.faq, function (item) {
    return _c("details", {
      key: item.question
    }, [_c("summary", [_vm._v(_vm._s(item.question)), _c("span", [_vm._v("＋")])]), _c("p", [_vm._v(_vm._s(item.answer))])]);
  }), 0)])])])]), _c("button", {
    staticClass: "float-consult",
    attrs: {
      type: "button",
      "aria-label": "咨询 Token Hub 服务"
    },
    on: {
      click: _vm.handleAppointment
    }
  }, [_c("HubIcon", {
    attrs: {
      name: "headset"
    }
  }), _c("span", [_vm._v("咨询")])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("p", {
    staticClass: "hub-hero__description"
  }, [_vm._v(" 专属算力整机独享、全程托管，Token 按用量付费。"), _c("br"), _vm._v(" 从金融业务出发，明确资源、模型、费用与交付。 ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "hub-heading"
  }, [_c("h2", {
    attrs: {
      id: "tokenhub-value-title"
    }
  }, [_vm._v("让模型、费用与交付更清晰。")]), _c("p", [_vm._v("围绕资源、用量、场景与服务，专注金融机构的实际需求。")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "hub-heading"
  }, [_c("h2", {
    attrs: {
      id: "tokenhub-workflow-title"
    }
  }, [_vm._v("Token Hub调用流程")]), _c("p", [_vm._v("业务发起请求，经 Token Hub 调用模型，处理结果返回业务应用。")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("strong", [_vm._v("内部赋能")]), _c("small", [_vm._v("让AI为企业工作赋能")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("strong", [_vm._v("客户服务")]), _c("small", [_vm._v("让AI为客户服务赋能")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "workflow-pills"
  }, [_c("span", [_vm._v("模型部署")]), _c("span", [_vm._v("运行维护")]), _c("span", [_vm._v("服务支持")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "workflow-models"
  }, [_c("span", [_vm._v("A")]), _c("span", [_vm._v("B")]), _c("span", [_vm._v("C")]), _c("span", [_vm._v("D")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "workflow-pills"
  }, [_c("span", [_vm._v("灵活切换")]), _c("span", [_vm._v("统一管理")]), _c("span", [_vm._v("按量扣费")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "workflow-return"
  }, [_c("span", [_vm._v("处理结果返回业务应用")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "hub-heading"
  }, [_c("h2", {
    attrs: {
      id: "tokenhub-services-title"
    }
  }, [_vm._v("企业专属算力，或按需调用")]), _c("p", [_vm._v("从服务与运维，同花顺Token Hub一站式解决")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "hub-heading"
  }, [_c("h2", {
    attrs: {
      id: "tokenhub-platform-title"
    }
  }, [_vm._v("平台能力支撑")]), _c("p", [_vm._v("从方案评估到业务运行，按机构需求组合服务能力。")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "hub-heading"
  }, [_c("h2", {
    attrs: {
      id: "tokenhub-security-title"
    }
  }, [_vm._v("安全与保障")]), _c("p", [_vm._v("围绕数据保护、操作追溯与稳定运行，更懂金融机构的合规要求。")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "hub-heading"
  }, [_c("h2", {
    attrs: {
      id: "tokenhub-delivery-title"
    }
  }, [_vm._v("从方案确认，"), _c("br"), _vm._v("到持续服务。")]), _c("p", [_vm._v("每一步都有明确的沟通内容与交付安排，"), _c("br"), _vm._v("让需求逐步落到可使用的服务。")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "business-top"
  }, [_c("h2", {
    attrs: {
      id: "tokenhub-business-title"
    }
  }, [_vm._v("同花顺的金融 AI，"), _c("br"), _vm._v("连接业务与技术。")]), _c("p", [_vm._v("同花顺 B2B 面向证券、期货等金融机构，依托问财金融对话、金融数据与专业分析能力，结合机构本地知识与业务系统，提供从云端能力接入、智能体应用到 APP 智能化建设的产品与解决方案。")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cooperation"
  }, [_c("strong", [_vm._v("从能力接入，到场景共建")]), _c("p", [_vm._v("根据机构的技术储备与建设目标，确认云端能力接入、业务应用建设或场景共建的合作范围。")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("h2", {
    attrs: {
      id: "tokenhub-contact-title"
    }
  }, [_vm._v("带上业务需求，"), _c("br"), _vm._v("一起确定下一步。")]), _c("p", [_vm._v("告诉我们业务用途、数据要求、预算与计划时间。")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };